// extracted by mini-css-extract-plugin
module.exports = {"Title":"ForbiddenView_Title__1yuaQ","SubTitle":"ForbiddenView_SubTitle__1h_nk","ForbiddenView":"ForbiddenView_ForbiddenView__19rC5"};